import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { addDataModalActions } from '../../../redux/profiles/patientHealthboard/add-data-modal';
import { redirectToSettings } from '../../../utils/appointments/redirect-utils';
import Button from '../../Button';
import Icon from '../../Icon';
import { getTitleAndDescriptionEmptyState } from '../utils';
import { VITALS_ACTIVITY_TYPE } from '../constants';
import styles from './index.styl';

const COMBINED_ACTIVITY_TYPE = [
  VITALS_ACTIVITY_TYPE.HEIGHT,
  VITALS_ACTIVITY_TYPE.WEIGHT,
  VITALS_ACTIVITY_TYPE.BMI,
];

export const EmptyState = ({
  formatMessage,
  type,
  isProvider,
  userId,
  mainUser,
}) => {
  const {
    description,
    titleButton,
    descriptionForAccount,
    withOutCapitalize,
  } = getTitleAndDescriptionEmptyState({
    formatMessage,
    type,
    isProvider,
  });
  const dispatch = useDispatch();
  const handleClick = () => {
    if (COMBINED_ACTIVITY_TYPE.includes(type)) {
      dispatch(addDataModalActions.open({ type }));
    } else {
      redirectToSettings(userId);
    }
  };
  return (
    <div className={styles.root}>
      <Icon name="ico-1000-graph" size={60} />
      <div className={styles.emptyStateDescription}>{description}</div>
      {descriptionForAccount && mainUser && (
        <div className={styles.emptyStateDescriptionAccount}>
          {descriptionForAccount}
        </div>
      )}
      {mainUser && titleButton && (
        <Button
          color="accent"
          className={cn(styles.addDataButton, {
            [styles.capitalize]: !withOutCapitalize,
          })}
          onClick={handleClick}
        >
          {titleButton}
        </Button>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  formatMessage: PropTypes.func,
  type: PropTypes.string,
  isProvider: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mainUser: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/EmptyState/index.jsx